import axios from "axios";
import url1 from '../../config.js'
const url=`${url1.url}/api/courselessonmapping`;

export default class CourseLessonMapping {
    constructor(){//courselessonmapping = {}) {
        // this.course_id = courselessonmapping.course_id || "";
        // this.lesson_id=courselessonmapping.lesson_id||"";
        // this.lessonOrder=courselessonmapping.lessonOrder||0
        // this.lessonStatus=courselessonmapping.lessonStatus||true;
    }

    //to get existing questions for ModifyQuestionsInALesson page
    static getExistingLessonsOfACourse=async (course_id, token)=>{
        console.log('get existing lessons to lesson model client',course_id);
        return axios.get(`${url}/lessonsofacourse/${course_id}`, {headers:{"x-auth-token":token}})
    }

    static getRemainingLessonsOfACourse=async(course_id, token)=>{
        return axios.get(`${url}/remaininglessonsofacourse/${course_id}`, {headers:{"x-auth-token":token}})
    }

    //save questions to a lesson on modifyquestionsinalesson.vue
    static putLessonsToCourse(course_id, courseLessonList, token) {
    console.log('put questions to lesson model client',course_id, courseLessonList);
       return axios.put(`${url}/savelessonstoacourse/${course_id}`, courseLessonList, {headers:{"x-auth-token":token}});
    }

    static putLessonStatusByLessonMaster(lesson_id, lessonStatus, token) {
           return axios.put(`${url}/changelessonstatusbymasterlessonstatus/${lesson_id}`, {lessonStatus:lessonStatus}, {headers:{"x-auth-token":token}});
        }

    static deleteCourse(course_id, token) {
        return (
            confirm("Are you sure you want to delete this course?") &&
            axios.delete(`${url}/${course_id}`, {headers:{"x-auth-token":token}})
            );
    }

  
    static putLessonStatusByCourse(course_id, lesson_id, lessonStatus, token) {
        //console.log('put admin user client',adminUserEmail,adminuser)
        return axios.put(`${url}/changelessonstatusbycourse/${course_id}/${lesson_id}`, {lessonStatus:lessonStatus}, {headers:{"x-auth-token":token}});
        }

}